var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-nav", style: [_vm.scrollLockStyles] },
    [
      _c(
        "div",
        { staticClass: "location-nav--wrap" },
        [
          _c("transition", { attrs: { name: "trs-location-nav-toggle" } }, [
            _vm.showLocationNav
              ? _c("div", { staticClass: "location-nav--bar" }, [
                  _c(
                    "button",
                    {
                      staticClass: "u-reset location-nav--prev",
                      attrs: {
                        disabled: _vm.prevLoc.location_name ? null : true
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.onLocationRequested(_vm.prevLoc.link)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "location-nav--btn-wrap location-nav--btn-wrap__prev"
                        },
                        [
                          _c("cmp-ink-ripple", {
                            staticClass: "location-nav--ripple btn--ink-ripple"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "location-nav--icon-wrap" },
                            [
                              _c("cmp-icon", {
                                staticClass: "location-nav--icon",
                                attrs: { symbol: "arrow-up", size: "small" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "u-reset location-nav--next",
                      attrs: {
                        disabled: _vm.nextLoc.location_name ? null : true
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.onLocationRequested(_vm.nextLoc.link)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "location-nav--btn-wrap location-nav--btn-wrap__next"
                        },
                        [
                          _c("cmp-ink-ripple", {
                            staticClass: "location-nav--ripple btn--ink-ripple"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "location-nav--description" },
                            [
                              _vm.nextLoc.location_name
                                ? _c("span", {
                                    staticClass: "location-nav--title",
                                    domProps: {
                                      textContent: _vm._s(_vm.nextLoc.title)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nextLoc.location_name
                                ? _c("span", {
                                    staticClass:
                                      "u-reset u-reset__h2 location-nav--loc-name",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.nextLoc.location_name
                                          ? _vm.nextLoc.location_name
                                          : " "
                                      )
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "location-nav--icon-wrap" },
                            [
                              _c("cmp-icon", {
                                staticClass: "location-nav--icon",
                                attrs: { symbol: "arrow-down", size: "small" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e0fc530e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0fc530e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/location-nav/index.vue
// module id = 365
// module chunks = 5